var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#AE43FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 12.2497V10.4163C5.83301 7.66634 7.66634 5.83301 10.4163 5.83301H19.583C22.333 5.83301 24.1663 7.66634 24.1663 10.4163V12.2497",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 17.75V19.5833C5.83301 22.3333 7.66634 24.1667 10.4163 24.1667H19.583C22.333 24.1667 24.1663 22.3333 24.1663 19.5833V17.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1426 12.4883L15.0009 15.3025L19.8226 12.5066",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 20.2888V15.293",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.864 9.7652L10.9307 11.3969C10.2707 11.7636 9.7207 12.6894 9.7207 13.4502V16.5577C9.7207 17.3186 10.2615 18.2444 10.9307 18.6111L13.864 20.2427C14.4874 20.591 15.514 20.591 16.1465 20.2427L19.0799 18.6111C19.7399 18.2444 20.2899 17.3186 20.2899 16.5577V13.4502C20.2899 12.6894 19.749 11.7636 19.0799 11.3969L16.1465 9.7652C15.514 9.4077 14.4874 9.4077 13.864 9.7652Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.10ccad75c429292b00e643f7ee1a82a4.svg";
export { ForwardRef as ReactComponent };